import React from 'react';
import '../css/LegalPages.css';

const PricingPage = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <h1>Simple Pricing</h1>
        <p>BlinkURL is currently free while we build the best link analytics experience.</p>
      </section>

      <section className="pricing-card">
        <h2>Free Plan</h2>
        <p className="price">$0 / month</p>
        <ul>
          <li>Unlimited URL shortening</li>
          <li>Click and unique visitor analytics</li>
          <li>Geography, device, and traffic-source insights</li>
          <li>Dashboard and link management</li>
          <li>Secure redirect and share-ready links</li>
        </ul>
        <p className="note">
          As BlinkURL grows, we may introduce advanced paid features. Existing core free features will remain accessible.
        </p>
      </section>
    </div>
  );
};

export default PricingPage;
